import { Component, OnInit } from '@angular/core';
import { DataProviderService } from '../../service/data-provider.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-subprojects',
  templateUrl: './subprojects.component.html',
  styleUrls: ['./subprojects.component.css']
})
export class SubprojectsComponent implements OnInit {
  projectData: any;

  constructor(private datapro: DataProviderService, public data: DataProviderService, public route: ActivatedRoute) {
    let id = this.route.snapshot.paramMap.get('projectNo');
    this.projectData = this.data.projectPage[id];
  }
  ngOnInit() {
    window.scrollTo(0,0);
  }

}
